import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";
import ReactGA from "react-ga";
import PublicWithToken from "./PublicWithToken";

class PublicContainer extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Switch>
                <Route path={"/public/:token"} component={PublicWithToken} />
            </Switch>
        );
    }
}

export default PublicContainer;
